/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/search/solr_search_collection.ts"/>

module DealerwareWebComponents {

    "use strict";

    var isFunction  = angular.isFunction;

    import DealerwareSolrSearchSmartFilter = DealerwareWebServices.DealerwareSolrSearchSmartFilter;


    export class VehicleSearchDirectiveController {

        public static $inject : string[] = [
            '$dealerwareSolrSearchVehicleCollection',
            '$mobilityCompanyAuthentication',
            'CurrentUser',
            '$timeout',
            '$state',
            '$filter',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'DealerwareTrimCollection',
            '$q',
            '$rootScope',
            '$controller',
            'AppConfig',
            'MicroFrontendOrigin',
            'ConvertUnits',
        ];

        public initialSearchComplete: boolean = false;
        public exportFilePrefix: string;
        public exportCols: any;
        public columns: any;
        public selectedVehicle: any;
        public trims: any;
        public allowModelManagement: boolean;
        public autocompletePlaceholder: string;
        public require: boolean;
        public forceAutocompleteSelection: boolean;
        public showManageModels: boolean;
        public showButtons: boolean;
        public onVehicleSelected: any;
        public showInactiveVehicles: boolean = false;
        public searchInProgress: boolean;
        public searchDisabled: boolean;
        public buttonsDisabled: boolean;

        public collectionListName: string = 'VehicleCollectionList';
        public landingPageController: any;
        public loader: any;
        public appConfig : any;
        public microFrontendOrigin : string;
        private isMetric: boolean;
        private isSuperUser: boolean;
        private hasConnectedCars: boolean;

        constructor(public $dealerwareSolrSearchVehicleCollection: any,
                    public auth: any,
                    public CurrentUser: any,
                    public $timeout: any,
                    public $state: any,
                    public $filter: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public DealerwareTrimCollection: any,
                    public $q : any,
                    public $rootScope: any,
                    public $controller: any,
                    public appConfig : any,
                    public microFrontendOrigin : string,
                    public ConvertUnits: any,
                    ) {
            var _self = this;

            this.isMetric = auth.location.settings.metric;
            this.isSuperUser = this.CurrentUser.user && this.CurrentUser.user.hasRole('superuser');
            this.hasConnectedCars = this.auth.location && this.auth.location.has_ccs;
            this.searchDisabled = false;
            this.buttonsDisabled = false;
            this.initVehicleColumns();

            this.$rootScope.$on('$authCompanyChanged', function(args: any) {
                _self.clear();
            });

            this.$rootScope.$on('$startContractOpened', function(args: any) {
                _self.clear();
            });

            this.exportFilePrefix = this.$filter('spaceless')(this.auth.location.name.toLowerCase()) + '_vehicles';
            $dealerwareSolrSearchVehicleCollection.locationId = this.auth.location.id;

            // Load Vehicle search with 'all' vehicles.
            //
            if (!this.require) {
                this.$timeout(() => {
                    this.$dealerwareSolrSearchVehicleCollection.searchArgs.searchText = 'all';
                    this.searchVehicles();
                    this.$dealerwareSolrSearchVehicleCollection.searchArgs.searchText = '';
                });
            }

            this.landingPageController = this.$controller('LandingPageController');
        }

        public initVehicleColumns() : void {
            var _self = this;

            this.columns = [{
                key: 'id',
                hidden: true
            },{
                key: 'license',
                header: 'License Plate',
                sortable: true,
                onClick: function(e: any, vehicle: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.vehicles.details',
                        { vehicleId: vehicle.data.id }
                    ));
                }
            },{
                key: 'stock_number',
                header: 'Stock #',
                sortable: true,
                onClick: function(e: any, vehicle: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.vehicles.details',
                        { vehicleId: vehicle.data.id }
                    ));
                }
            },{
                key: 'model_year',
                header: 'Model Year'
            },{
                key: 'make',
                header: 'Make'
            },{
                key: 'model_name',
                header: 'Model'
            },{
                key: 'mileage_in_km',
                header: 'Mileage',
                sortable: true,
                dataFilter: v => _self.convertMileage(v),
            },{
                key: 'physical_location',
                header: 'Physical Location',
                sortable: true
            },{
                key: 'current_state',
                header: 'Current State',
                sortable: true
            },{
                key: 'connected',
                header: 'Connected Car?',
                sortable: true,
                iconFn: function(vehicle: any) {
                    return vehicle.data.connected ? 'check' : '';
                }
            },{
                key: 'toll_tag_number',
                header: 'Toll Barcode',
                hidden: this.auth.location && !this.auth.location.has_tolls
            },{
                key: 'firmware_version',
                header: 'Firmware',
                hidden: !this.isSuperUser || !this.hasConnectedCars
            }];

            this.exportCols = [
                { header: 'License Plate', dataKey: 'license' },
                { header: 'Stock #', dataKey: 'stock_number' },
                { header: 'VIN', dataKey: 'vin' },
                { header: 'Model Year', dataKey: 'model_year' },
                { header: 'Make', dataKey: 'make' },
                { header: 'Model', dataKey: 'model_name' },
                { header: 'Mileage', dataFilter: modelData => this.convertMileage(modelData.mileage_in_km) },
                { header: 'Physical Location', dataKey: 'physical_location' },
                { header: 'Current State', dataKey: 'current_state' },
                { header: 'Connected Car', dataKey: 'connected' },
                { header: 'Toll Barcode', dataKey: 'toll_tag_number' }
            ];

            if (this.auth.location && this.auth.location.has_tolls) {
                this.exportCols.push({ header: 'Toll Barcode', dataKey: 'toll_tag_number' });
            }

            if (this.isSuperUser && this.hasConnectedCars) {
                this.exportCols.push({ header: 'Firmware', dataKey: 'firmware_version' });
            }
        }

        private convertMileage(km): string {
            const convertedValue = this.isMetric
              ? km
              : this.ConvertUnits.kmToMiles(km);
            return convertedValue.toFixed();
        }

        public pageTransitionError(response : any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public vehicleSelected(record : any) : void {

            if (record instanceof DealerwareSolrSearchSmartFilter) {

                this.$dealerwareSolrSearchVehicleCollection.searchArgs.searchText = record.name;
                this.searchVehicles();
            }
            else if (record) {
                this.selectedVehicle = record;
                if (this.onVehicleSelected && isFunction(this.onVehicleSelected)) {
                    this.onVehicleSelected({record: record});
                }
            }
        }

        public searchTextChanged(val : string) {
        }

        public allowManageModels() : boolean {
            return this.allowModelManagement && this.CurrentUser.user && this.CurrentUser.user.hasRole('trim_manager');
        }

        public showManageModelsPanel(show: boolean) : void {
            var _self = this;

            if (show && !this.trims) {
                var loader = this.$dealerwareLoading.show('Loading...');
                this.DealerwareTrimCollection.index({
                    promise: true,
                    params: {
                        location_id: this.auth.location.id,
                        sort_by: 'year',
                        sort_direction: 'desc'
                    }
                }).then(
                    function(returnValue: any) { _self.trims = returnValue },
                    function(response: any) { _self.$dealerwareNotification.apiError(response); }
                ).finally(function() {
                    loader.close();
                });
            }
            this.showManageModels = show;
            this.searchDisabled = show;
            this.buttonsDisabled = show;
        }


        private _acq : any;

        public get autoCompletePromise() : any {
            return this._acq;
        }

        public set autoCompletePromise(acq : any) {
            this._acq = acq;
        }

        public cancelActiveAutoCompletePromise() {
            if (this._acq) {
                this._acq.resolve([]);
            }
            this._acq = undefined;
        }

        public set defaultSearchText(text: string) {
            var _self = this;

            if (text && this.$dealerwareSolrSearchVehicleCollection) {
                this.$dealerwareSolrSearchVehicleCollection.searchArgs.searchText = text;
                this.searchVehicles();
            }
        }

        public newAutoCompletePromise() {
            this.cancelActiveAutoCompletePromise();
            this._acq = this.$q.defer();
            return this._acq;
        }

        public blurAutoComplete() {
            $('#vehicleSearchAutoComplete').find('input')[0].blur();
        }

        public autoCompleteSearch() {
            var _self =this;
            var _deferred = this.newAutoCompletePromise();;

            if (this.searchInProgress) {
                this.$timeout(function() {
                    _self.cancelActiveAutoCompletePromise();
                },1);
            } else {
                this.$dealerwareSolrSearchVehicleCollection.searchArgs.locationId = this.auth.location.id;
                this.$dealerwareSolrSearchVehicleCollection.searchArgs.active = !this.showInactiveVehicles || undefined;

                if (this.forceAutocompleteSelection) {
                    this.$dealerwareSolrSearchVehicleCollection.autoCompleteSearchWithoutFilters().then(
                        function(returnValue: any) {
                            _deferred.resolve(returnValue.data);
                            _self.autoCompletePromise = undefined;
                        },
                        function(response: any) {
                            _deferred.reject([]);
                            _self.autoCompletePromise = undefined;
                        }
                    );
                } else {
                    this.$dealerwareSolrSearchVehicleCollection.autoCompleteSearch().then(
                        function(returnValue : any) {
                            _deferred.resolve(returnValue.data);
                            _self.autoCompletePromise = undefined;
                        },
                        function(response : any) {
                            _deferred.reject([]);
                            _self.autoCompletePromise = undefined;
                        }
                    );
                }
            }
            return _deferred.promise;
        }


        public searchVehicles(sortBy?: string, sortDirection?: string) : void {
            var _self = this;

            this.cancelActiveAutoCompletePromise();
            this.updateSorting(sortBy, sortDirection);
            this.blurAutoComplete();

            if (!sortBy) {
                this.searchInProgress = true;
                sortBy = "created_at";
                sortDirection = "desc";
            } else {
                this.loader = this.$dealerwareLoading.show('Loading...');
            }

            this.$dealerwareSolrSearchVehicleCollection.searchArgs.sortBy = sortBy;
            this.$dealerwareSolrSearchVehicleCollection.searchArgs.sortDirection = sortDirection;
            this.$dealerwareSolrSearchVehicleCollection.searchArgs.locationId = this.auth.location.id;
            this.$dealerwareSolrSearchVehicleCollection.searchArgs.active = !this.showInactiveVehicles || undefined;

            this.$dealerwareSolrSearchVehicleCollection.search().then(
                function() {
                    _self.$dealerwareSolrSearchVehicleCollection.searchResults.subject = 'vehicle';
                    if (_self.$dealerwareSolrSearchVehicleCollection.searchResults.recordTotal !== 1) {
                        _self.$dealerwareSolrSearchVehicleCollection.searchResults.subject += 's';
                    }
                },
                function(response: any) { console.log("error:",response); }
            ).finally(function() {
                _self.initialSearchComplete = true;
                _self.searchInProgress = false;
                if (_self.loader) { _self.loader.close(); }
            });
        }

        public updateSorting(sortBy: string, sortDirection: string) : void {
            this.columns.forEach((c: any) => {
                if (c.key === sortBy || (c.sortBy !== undefined && c.sortBy === sortBy)) {
                    c.sortDirection = sortDirection;
                } else {
                    c.sortDirection = undefined;
                }
            });
        }

        public clear() : void {
            var collection = this.$dealerwareSolrSearchVehicleCollection;

            collection.searchArgs.clear();
            if (collection.searchResults) { collection.searchResults.clear(); }
        }

        public onCreateVehicleSuccess(vehicle: any) : void {
            this.vehicleSelected(vehicle);
        }
    }

    getDealerwareWebComponentsModule().controller('VehicleSearchDirectiveController',VehicleSearchDirectiveController);

    export class VehicleSearchDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleSearchDirectiveController';
        public controllerAs     : string    =   'vehicleSearchController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            onVehicleSelected: '&',
            defaultSearchText: '=',
            showButtons: '=',
            allowModelManagement: '=',
            autocompletePlaceholder: '@',
            require: '=',
            forceAutocompleteSelection: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/search/vehicle_search_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehicleSearch",() => new VehicleSearchDirective());
}
